<pos-header title="My Profile"></pos-header>

<div class="content">

  <form *ngIf="form" [formGroup]="form">

    <div class="mb-gutter-double">
      <p class="font-medium mb-6px">Email Address</p>
      <input class="form-control text-lowercase width-300px" type="email" disabled value={{user.email}}>
    </div>

    <div class="form-group mb-gutter-double">
      <p class="font-medium mb-6px">Current Password</p>
      <input class="form-control width-300px" type="password" formControlName="currentPassword">
      <span class="help-text invalid" *ngIf="currentPassword.invalid && currentPassword.touched">
        Valid current password is required
      </span>
    </div>

    <div class="form-group mb-gutter-double auth-form-group">
      <p class="font-medium mb-6px">New Password</p>
      <input type="password" class="form-control width-300px password-conditions-field" formControlName="newPassword">
      <span class="help-text invalid" *ngIf="newPassword.hasError('required') && newPassword.touched">
        Valid new password is required
      </span>
      <span class="help-text invalid" *ngIf="newPassword.valid && currentPassword.valid && newPassword.value === currentPassword.value">
        New password cannot be same as old password
      </span>
      <div class="password-conditions">
        <div class="header">Your Password must contain:</div>
        <ul class="conditions-list">
          <li *ngFor="let check of passwordRegex"
            [class.completed]="check.regex.test(newPassword.value) && newPassword.dirty"
            [class.error]="!check.regex.test(newPassword.value) && newPassword.dirty">{{check.label}}</li>
        </ul>
      </div>
    </div>

    <div class="form-group mb-gutter-double">
      <p class="font-medium mb-6px">Confirm Password</p>
      <input class="form-control width-300px" type="password" formControlName="confirmPassword">
      <span class="help-text invalid" *ngIf="confirmPassword.invalid && confirmPassword.touched">
        Valid confirm password is required
      </span>
      <span class="help-text invalid" *ngIf="newPassword.valid && confirmPassword.valid && newPassword.value !== confirmPassword.value">
        Password does not match
      </span>
    </div>

  </form>

  <div class="form-group">
    <button class="btn btn-primary justify-content-center" (click)="update()">Update</button>
  </div>

</div>
